<!-- ================= Filters ================= -->
<ion-row class="ion-align-items-center">
  <ion-col size="12" size-md="auto">
    <h6 class="comp-header">{{ exitedMode ? 'Exited Team DWM' : 'Review Team DWM' }}</h6>
  </ion-col>
  <ion-col size="12" size-md>
    <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
      <button class="center-content clear-filter-btn">
        <u class="cp link fs_14ForMobile" (click)="applyDataFilters('', '', false)">Clear Filter</u>
      </button>

      <ng-select class="w-100 mw-sm-150 mat-height40 mat-input-style team-emp-dropdown" *ngIf="employeeDropdownList" [clearable]="true" placeholder="{{ exitedMode ? 'Select Exited Employee' : 'Select Employee' }}" [groupBy]="groupByExitStatus" (change)="applyDataFilters($event, 'selectedEmpId')" [(ngModel)]="selectedFilters.selectedEmpId" dropdownPosition="bottom">
        <ng-option [value]="item.id" *ngFor="let item of employeeDropdownList">{{ item.firstName }} {{ item.lastName }}</ng-option>
      </ng-select>

      <mat-form-field *ngIf="!exitedMode" class="w-100 mw-sm-150 mat-height40 mat-input-style">
        <input readonly matInput [matDatepicker]="fromToDate" placeholder="DD/MM/YYYY" [(ngModel)]="selectedFilters.selectedDate" (dateChange)="applyDataFilters($event.value, 'selectedDate')" />
        <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
        <mat-datepicker #fromToDate></mat-datepicker>
      </mat-form-field>

      <!-- <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
        <mat-select placeholder="Select Year" (selectionChange)="applyDataFilters($event.value, 'selectedYear')" [(ngModel)]="selectedFilters.selectedYear" dropdownPosition="bottom">
          <mat-option *ngFor="let year of listOfYears" [value]="year.key">
            {{
            year.value
            }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
    </div>
  </ion-col>
</ion-row>

<div class="table-card-box mb-15" *ngIf="selectedFilters.selectedEmpId">
  <ion-row>
    <ion-col size>
      <div class="phi-flex-wrap-center phi-gap-12 mb-5">
        <button (click)="onClickDeleteRecord()" [disabled]="disableDelete" *ngIf="selectedTaskList?.length > 0 && selectedFilters?.isCutoffTaskEditable && !hasNewEntry" class="materialBtnIcon red fs-14 fs_12ForMobile font_semibold">
          <span class="material-icons fs-20">delete</span>
        </button>
        <mat-form-field class="w-100 mw-sm-175 mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" (input)="onSearch($event)" [(ngModel)]="selectedFilters.searchString" [disabled]="!selectedFilters.selectedEmpId" />
        </mat-form-field>
        <ng-select class="w-100 mw-sm-125 mat-height40 mat-input-style" *ngIf="dwmManagerUser" [clearable]="true" placeholder="Status" (change)="applyDataFilters($event, 'selectedStatus')" [(ngModel)]="selectedFilters.selectedStatus" dropdownPosition="bottom">
          <ng-option [value]="item" *ngFor="let item of checkDwmStatus">{{ commonFunctions.formatText(item) }}</ng-option>
        </ng-select>
        <ng-select class="w-100 mw-sm-125 mat-height40 mat-input-style" *ngIf="dwmManagerUser" [clearable]="true" placeholder="Criticality" (change)="applyDataFilters($event, 'selectedCriticality')" [(ngModel)]="selectedFilters.selectedCriticality" dropdownPosition="bottom">
          <ng-option [value]="item" *ngFor="let item of checkDwmCriticality">{{ item }}</ng-option>
        </ng-select>
      </div>
    </ion-col>
    <ion-col size="auto">
      <div class="phi-flex-wrap-center phi-gap-12">
        <button class="dwm_btn fs-14 fs_12ForMobile" *ngIf="selectedTaskList?.length > 0 && selectedFilters?.isCutoffTaskEditable && !hasNewEntry" (click)="resignSelectDwms()" [disabled]="!selectedFilters.selectedEmpId">Reassign DWM</button>
        <!-- <button type="button" class="dwm_btn fs-14 fs_12ForMobile" *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd" (click)="saveRNDTask()">Save</button>
        <button type="button" class="dwm_btn fs-14 fs_12ForMobile" *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd" (click)="addRNDTask()">+Add R&D Task</button> -->
        <button type="button" class="dwm_btn fs-14 fs_12ForMobile" *ngIf="selectedFilters.selectedEmpId && !exitedMode" (click)="showMtdView()">MTD View</button>
        <button *ngIf="dwmSkippDay.isSkipped" class="applied-skip-day" (click)="onClickSkipDay()" [innerHTML]="dwmSkippDay.isSkippedText"></button>
        <div *ngIf="!exitedMode" class="download-btns phi-flex-wrap-center phi-gap-12">
          <img src="assets/svg/pdf.svg" class="download-img-btn" (click)="downloadReport('pdf')" />
          <img src="assets/svg/excel.svg" class="download-img-btn" (click)="downloadReport('excel')" />
          <!-- <button class="transparent-ghost-btn light-border icon-btn" matTooltip="Refresh Data" (click)="refreshData()">
            <mat-icon>refresh</mat-icon>
          </button> -->
        </div>
      </div>
    </ion-col>
  </ion-row>

  <div class="table-container" *ngIf="selectedFilters.selectedEmpId">
    <table class="hover">
      <thead>
        <tr>
          <th class="mat-checkbox-style text-center">
            <mat-checkbox value="true" [disabled]="!selectedFilters?.isCutoffTaskEditable" [(ngModel)]="isAllSelected" matTooltip="Select all tasks on this page" (change)="selectALLDwms($event, paginatedData)"></mat-checkbox>
          </th>
          <ng-container *ngFor="let item of teamTableHeaders; let i = index">
            <ng-container *ngIf="(checkIfIsRNDOrL4AndAboveEmployee?.isRnd || item?.key !== 'action') && !(exitedMode && item?.key === 'dwmStatus')">
              <th class="fs-14 fs_12ForMobile font_bold cl-black sortable" (click)="onSort(item.key)">
                <div class="verticle-center justify-content-space-between icon-style">
                  {{ item.label }}
                  <div class="sort-records-container d-flex flex-column ml-5">
                    <ion-icon name="caret-up-outline" [class.active]="tableState.sortColumn === item.key && tableState.sortDirection === 'asc'"></ion-icon>
                    <ion-icon name="caret-down-outline" [class.active]="tableState.sortColumn === item.key && tableState.sortDirection === 'desc'"></ion-icon>
                  </div>
                </div>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </thead>

      <tbody *ngIf="paginatedData?.length != 0">
        <tr *ngFor="let item of paginatedData; let i = index">
          <!-- Check Box -->
          <td class="mat-checkbox-style text-center">
            <mat-checkbox [checked]="item?.checkboxCheck" [(ngModel)]="item.checkboxCheck" (change)="selectSingleDwm($event, item, i)" [disabled]="item?.dwmStatus === 'Completed' || !item?.isCutoffTaskEditable"></mat-checkbox>
          </td>

          <!-- Remaining Data -->
          <td>{{ item?.categoryName }}</td>
          <td>
            <span *ngIf="!item.isNew else showProductId">{{ item?.productId }}</span>
            <ng-template #showProductId>
              <ng-select class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Product" [(ngModel)]="item.productId" [items]="productList" bindLabel="productNumber" bindValue="productId" appendTo="body" dropdownPosition="top" (change)="onProductChange(item)"></ng-select>
            </ng-template>
          </td>
          <td>{{ item?.plantLocation }}</td>
          <td>
            <span *ngIf="!item.isNew else showActionable">{{ item?.actionable }}</span>
            <div *ngIf="exitedMode" class="text-muted fs-12" [matTooltip]="item?.dateList">
              (Start: {{ item?.dateFrom | date: 'dd MMM yyyy' }}<ng-container *ngIf="item?.openCount > 1"> | End: {{ item?.dateTo | date: 'dd MMM yyyy' }} | {{ item.openCount }} dates</ng-container>)
            </div>
            <ng-template #showActionable>
              <textarea rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item.actionable)" class="min-w-sm-150" [class.field-required]="item?.isRequiredActionable" [(ngModel)]="item.actionable" placeholder="Type here.."></textarea>
            </ng-template>
          </td>
          <td>
            <span *ngIf="!item.isNew else showDwmDuration">{{ item?.dwmDuration }}</span>
            <ng-template #showDwmDuration>
              <input matInput class="dwm-input table-input" type="text" inputmode="numeric" placeholder="HH:MM" maxlength="5" [disabled]="item.categoryName !== 'R&D-Project'" [(ngModel)]="item.dwmDuration" (keydown)="onDurationInput(item, $event)" (input)="onDurationInput(item, $event)" (blur)="onDurationBlur(item)" />
              <mat-error *ngIf="maxDurationError">Maximum allowed duration is 24:00</mat-error>
            </ng-template>
          </td>
          <td>{{ item?.timeFrom | timeAmPm }}</td>
          <td>{{ item?.timeTo | timeAmPm }}</td>
          <td>
            <span *ngIf="item.isNew else showFrequency">{{ item?.dwmFrequency }}</span>
            <ng-template #showFrequency>{{ commonFunctions.formatText(item?.dwmFrequency) }}</ng-template>
          </td>
          <td *ngIf="!exitedMode">
            <div class="dwm-status-icons">
              <button class="transparent-ghost-btn radius-100" (click)="changeStatusOrComment(item, 'Not_Started')">
                <mat-icon class="dwm-status-icon not-started" [matTooltip]="dwmGenericServiceService.getStatusLabel('Not_Started')" [ngClass]="{ 'active': item?.dwmStatus === 'Not_Started', 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">cancel</mat-icon>
              </button>
              <button class="transparent-ghost-btn radius-100" (click)="changeStatusOrComment(item, 'In_Progress')">
                <mat-icon class="dwm-status-icon in-progress" [matTooltip]="dwmGenericServiceService.getStatusLabel('In_Progress')" [ngClass]="{ 'active': item?.dwmStatus === 'In_Progress', 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">radio_button_checked</mat-icon>
              </button>
              <button class="transparent-ghost-btn radius-100" [disabled]="isExitedSelectedDate" (click)="changeStatusOrComment(item, 'Completed')">
                <mat-icon class="dwm-status-icon complete" [matTooltip]="dwmGenericServiceService.getStatusLabel('Completed')" [ngClass]="{ 'active': item?.dwmStatus === 'Completed' && !item?.doneWithDelay, 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">check_circle</mat-icon>
              </button>
              <button class="transparent-ghost-btn radius-100" (click)="changeStatusOrComment(item, 'Done_with_delay')" [disabled]="!isExitedSelectedDate">
                <mat-icon class="dwm-status-icon complete-delay" [matTooltip]="dwmGenericServiceService.getStatusLabel('Done_with_delay')" [ngClass]="{ 'active': item?.dwmStatus === 'Done_with_delay' || item?.doneWithDelay, 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">check_circle</mat-icon>
              </button>
            </div>
          </td>
          <td>{{ item?.empComments }}</td>
          <td>
            <textarea rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item?.managerComments)" class="min-w-sm-150" [(ngModel)]="item.managerComments" placeholder="Type here.." (change)="changeStatusOrComment(item, '')" [disabled]="dwmSkippDay.empComment === 'Accept skip day' || !item?.isCutoffTaskEditable"></textarea>
          </td>
          <td class="text-center">
            <span *ngIf="!item.isNew else attachFile">
              <button *ngIf="item?.dwmDoc" class="clear-filter-btn text-blue" (click)="onDownload(item)">Download</button>
            </span>

            <ng-template #attachFile>
              <!-- <button *ngIf="item?.dwmDoc" class="clear-filter-btn text-blue" (click)="onDownload(item)">Download</button> -->
              <input type="file" multiple #fileInput hidden (change)="uploadDWMAttachments($event, item)" />

              <span class="attachment-icon cp" matTooltip="Upload" *ngIf="!item?.hasSavedAttachments" (click)="fileInput.click()">
                <img class="attachment" src="assets/icon/attachment.svg" />
              </span>

              <span *ngIf="item?.hasSavedAttachments" class="see-attachment-wrapper">
                <span class="see-attachment cp" (click)="onDownload(item)">See Attachment</span>
                <span class="remove-attachment cp" (click)="removeSavedAttachments(item)" title="Remove Attachment">✕</span>
              </span>
            </ng-template>
          </td>
          <td>
            <button mat-icon-button color="success" (click)="auditpopup(item.id)">
              <ion-icon name="document-text-outline"></ion-icon>
            </button>
          </td>
          <ng-container *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd || item?.isNew">
            <td class="text-center">
              <button *ngIf="item?.isNew" class="p-0 h-auto" type="button" mat-icon-button color="warn" matTooltip="Removes" [disabled]="selectedTaskList?.length > 0 || !item.isCutoffTaskEditable" (click)="removeTask(i)">
                <ion-icon name="trash-outline"></ion-icon>
              </button>
            </td>
          </ng-container>
          <!-- End -->
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!selectedFilters.selectedEmpId" class="text-center p-20 fs-14">Please select an employee to view DWM records.</div>

  <div class="phi-flex-wrap-center-space-between-gap6 mt-10" *ngIf="paginatedData?.length != 0">
    <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries</ion-label>

    <div class="phi-flex-wrap-center phi-gap-12">
      <div class="phi-flex-wrap-center phi-gap-8">
        <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
        <mat-form-field class="w70px mat-height40 mat-input-style">
          <mat-select placeholder="Select" (selectionChange)="changePageSize($event.value)" [value]="pageSize">
            <mat-option [value]="25">25</mat-option>
            <mat-option [value]="50">50</mat-option>
            <mat-option [value]="75">75</mat-option>
            <mat-option [value]="100">100</mat-option>
          </mat-select>
        </mat-form-field>
        <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
      </div>

      <ul class="dt_pagination">
        <li class="active fs-16 fs_14ForMobile font_regular">
          {{ currentPage }}
        </li>
        <span class="fs-14 fs_12ForMobile font_regular p-10">of {{ totalPages }}</span>
        <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage - 1)" [ngClass]="{ disableBtn: currentPage === 1 }">&lt;</li>
        <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage + 1)" [ngClass]="{ disableBtn: currentPage === totalPages }">&gt;</li>
      </ul>
    </div>
  </div>
</div>
